var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleArrowsLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.24 15.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82,13.39a.43.43,0,0,1,0,.6l-1,1a.42.42,0,0,1-.6,0L.12,7.85A.47.47,0,0,1,0,7.54a.42.42,0,0,1,.12-.3L7.24.12a.43.43,0,0,1,.6,0l1,1a.43.43,0,0,1,0,.6L3,7.54Zm2.45-5.85L17.11,1.7a.42.42,0,0,0,0-.6l-1-1a.43.43,0,0,0-.6,0L8.42,7.24a.42.42,0,0,0-.12.3.47.47,0,0,0,.12.31L15.54,15a.42.42,0,0,0,.6,0l1-1a.42.42,0,0,0,0-.6Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowsLeft);
export default __webpack_public_path__ + "static/media/double-arrows-left.2210cab0b80b0bbf8cf8e9c3416d0cb4.svg";
export { ForwardRef as ReactComponent };